const toUrl = (url: string) => {
  try {
    return 'http://' + url.replace(/(^\w+:|^)\/\//, '');
  } catch (e) {
    return url;
  }
};

export default toUrl;
